import React, { FunctionComponent } from "react";
import "./index.scss";

const RightArrowIcon: FunctionComponent = () => (
  <i className="RightArrowIcon bi bi-arrow-right" />
);

export default RightArrowIcon;
